module.exports = __webpack_public_path__ + "static/media/usa_4.08909985.jpg";